import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { LocalStorageService } from 'angular-2-local-storage';
// import { parse } from 'url';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly whiteListedDomains = [];
  private readonly disallowedDomains = [];

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private localStorageService: LocalStorageService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token: string = this.localStorageService.get('token');

    let modifiedReq = req.clone({
      setHeaders: { 'Accept-Language': 'ru' }
    });

    if (token && !req.headers.has('Authorization')) {
      modifiedReq = modifiedReq.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
      return next.handle(modifiedReq);
    }
    
    modifiedReq = modifiedReq.clone({
      headers: modifiedReq.headers.delete('Authorization')
    });

    return next.handle(modifiedReq);
  }

  isDisallowedDomains(req: HttpRequest<any>): boolean {
    const requestedUrl: URL = new URL(req.url, this.document.location.origin);

    return (
      this.disallowedDomains.findIndex((route: string | RegExp) => {
        if (typeof route === 'string') {
          const parsedRoute: URL = new URL(route, this.document.location.origin);
          return parsedRoute.hostname === requestedUrl.hostname && parsedRoute.pathname === requestedUrl.pathname;
        }

        if (route instanceof RegExp) {
          return route.test(req.url);
        }

        return false;
      }) > -1
    );
  }

  isWhitelistedDomain(req: HttpRequest<any>) {
    // const requestUrl: any = parse(req.url, false, true);
    // return (
    //   requestUrl.host === null ||
    //   this.whiteListedDomains.findIndex((domain: string | RegExp) =>
    //     typeof domain === 'string'
    //       ? domain === requestUrl.host
    //       : domain instanceof RegExp
    //       ? domain.test(requestUrl.host)
    //       : false,
    //   ) > -1
    // );
  }
}
